<template>
  <div class="flex flex-col w-full h-full">
    <div class="flex flex-col h-full p-2 bg-white divide-gray-200 rounded-lg dark:bg-dark-box-background">
      <ul class="relative min-w-full">
        <div v-if="element.item_type != 'clause' && element.item_type != 'operator'" class="relative">
          <div class="relative flex items-center justify-center min-w-full">
            <div
              class="flex-1 min-w-full bg-white rounded-md dark:bg-dark-screen-background border-light-divider-border dark:border-dark-divider-border">
              <div class="min-w-full">
                <Listbox v-if="element.name"
                         v-model="element.operators"
                         :disabled="true"
                         as="div"
                         class="relative z-20 flex-1 w-full mb-2">
                  <div class="relative w-full h-full">
                    <ListboxButton
                      class="relative z-20 w-full h-full py-1 pl-3 pr-10 overflow-hidden bg-white border rounded-md cursor-default text-start focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue dark:bg-dark-screen-background border-light-divider-border dark:border-dark-divider-border focus:outline-none">
                      <span class="block py-1 truncate text-thin text-light-body-text dark:text-dark-body-text">{{ metric.name }}</span>
                      <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <ChevronDown class="w-5 h-5 text-gray-400" aria-hidden="true" />
                      </span>
                    </ListboxButton>
                  </div>
                </Listbox>

                <div
                  v-if="element?.operator?.value !== '__ISNULL__' && element?.operator?.value !== '__IS_NOT_NULL__' && element.name"
                  class="flex w-full rounded-md">
                  <div
                    v-if="element.id == 'name'"
                    scope="col"
                    class="w-full py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <div class="relative flex focus-within:z-10">
                      <AutoCompleteInput
                        v-model="element.value"
                        class="w-full bg-transparent border-none"
                        :value="element.value"
                        :icon="undefined"
                        :is-async="false"
                        :is-box-background="isBoxBackground"
                        :placeholder="$t('Name')"
                        type="text"
                        classes="relative text-light-body-text dark:text-dark-body-text bg-white dark:bg-dark-screen-background rounded-md"
                        input-classes="overflow-hidden  focus:outline-none focus:ring-blue-light focus:border-blue-light  w-full rounded-md border-light-divider-border dark:border-dark-divider-border"
                        @changed="
                          (e) => {
                            setValue(e)
                          }
                        "
                        @chosen="
                          (e) => {
                            setValue(e)
                          }
                        " />
                    </div>
                  </div>
                  <div
                    v-else-if="element.id == 'status'"
                    scope="col"
                    class="relative w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <MultiSelectInput
                      v-model:current-items="status"
                      :value="element.value"
                      name="plans_status"
                      :items="$store.state.data?.goal_statuses"
                      label-attr="name"
                      value-attr="value"
                      :allow-null="true"
                      :icon="status_icon"
                      :label="$t('Status')"
                      classes="relative w-full h-[42px] -mt-[1px]"
                      input-classes="relative sm:text-sm appearance-none font-medium text-gray-700 text-left block h-[42px] px-3 py-1 mt-0.5 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                      :placeholder="$t('Status')"
                      :show-label="false" />
                  </div>
                  <div
                    v-else-if="element.id == 'companies'"
                    scope="col"
                    class="w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <AsyncMultiSelectCompaniesInput
                      :add-label="$t('Companies')"
                      :initial-value="element.value"
                      :clear-on-select="true"
                      :is-box-background="true"
                      classes="w-full h-[42px]"
                      input-classes="appearance-none text-left block h-[42px] px-3 py-2 border !border-gray-300 rounded-md  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                      name="companies"
                      value-attr="id"
                      :endpoint="`/api/organizations/${$store.state.organization.id}/records/filter/`"
                      endpoint-method="post"
                      search-field="name"
                      type="text"
                      :placeholder="$t('companies/Opportunities')"
                      :debounce="500"
                      @update:currentItems="
                        ($event) => {
                          setValue($event)
                        }
                      " />
                  </div>
                  <div
                    v-else-if="element.id == 'contacts'"
                    scope="col"
                    class="w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <AsyncMultiSelectContactsInput
                      :add-label="$t('Contacts')"
                      :initial-value="element.value"
                      :clear-on-select="true"
                      :is-box-background="true"
                      classes="w-full h-[42px]"
                      input-classes="w-full h-[42px] appearance-none text-left block px-3 border border-gray-300 rounded-md  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                      name="contacts"
                      value-attr="id"
                      :endpoint="`/api/organizations/${$store.state.organization.id}/records/filter/`"
                      endpoint-method="post"
                      search-field="name"
                      type="text"
                      :placeholder="$t('Contacts')"
                      :debounce="500"
                      @update:currentItems="
                        ($event) => {
                          setValue($event)
                        }
                      " />
                  </div>
                  <div
                    v-else-if="element.id == 'collaborators'"
                    scope="col"
                    class="w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <MultiSelectInput
                      v-model:current-items="collaborators"
                      :value="element.value"
                      name="collaborators"
                      :icon="user_menu_icon"
                      :items="$store.state.data?.users"
                      label-attr="full_name"
                      :allow-null="true"
                      value-attr="id"
                      :label="$t('Users')"
                      classes="w-full h-[42px] dark:text-dark-body-text"
                      input-classes="w-full h-[42px] sm:text-sm appearance-none font-medium text-gray-700 text-left block px-3 py-1 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                      selection-text="Members (%COUNT)"
                      :placeholder="$t('Team Members')"
                      :show-label="false" />
                  </div>
                  <div
                    v-else-if="element.id == 'tags'"
                    scope="col"
                    class="w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <MultiSelectInput
                      v-model:current-items="interaction_types"
                      :value="element.value"
                      name="tags"
                      :icon="tags_icon"
                      :items="$store.state.data.actions_tags"
                      value-attr="id"
                      label-attr="name"
                      :allow-null="true"
                      :label="$t('Tags')"
                      classes="w-full min-w-[200px]"
                      input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                      :placeholder="$t('Tag')"
                      :show-label="false" />
                  </div>
                  <div
                    v-else-if="element.id == 'type'"
                    scope="col"
                    class="w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <MultiSelectInput
                      v-model:current-items="interaction_types"
                      :value="element.value"
                      name="type"
                      :icon="user_menu_icon"
                      :items="$store.state.data.interaction_types"
                      value-attr="value"
                      label-attr="label"
                      :allow-null="true"
                      :label="$t('Types')"
                      classes="w-full min-w-[200px]"
                      input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                      selection-text="Types (%COUNT)"
                      :placeholder="$t('Type')"
                      :show-label="false" />
                  </div>
                  <div
                    v-else-if="element.id == 'category'"
                    scope="col"
                    class="w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <MultiSelectInput
                      v-model:current-items="interaction_categories"
                      name="category"
                      :icon="user_menu_icon"
                      :items="$store.state.data.interaction_categories"
                      value-attr="value"
                      label-attr="label"
                      :allow-null="true"
                      :label="$t('Categories')"
                      classes="w-full min-w-[200px]"
                      input-classes="sm:text-sm appearance-none font-medium text-gray-700 text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-white focus:ring-1 focus:outline-none focus:ring-blue-light focus:border-blue-light dark:border-dark-divider-border dark:bg-dark-box-background"
                      selection-text="Categories (%COUNT)"
                      :placeholder="$t('Category')"
                      :show-label="false" />
                  </div>
                  <div
                    v-else-if="element.id == 'date' || element.id == 'start_date'"
                    scope="col"
                    class="w-full h-[42px] py-3 text-xs font-medium tracking-wider text-left transform dark:bg-dark-box-background text-common-grey">
                    <DatePicker
                      v-model="due_date_range"
                      :is-dark="$store.state.ui.darkMode"
                      :input-debounce="500"
                      mode="range"
                      is-range
                      class="w-full h-[42px] bg-white dark:bg-dark-screen-background"
                      :attributes="[
                        {
                          key: 'today',
                          dot: true,
                          dates: new Date()
                        }
                      ]"
                      :popover="{ visibility: 'click' }"
                      range>
                      <template #default="{ inputValue, inputEvents }">
                        <div class="relative flex-grow">
                          <svg
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            class="absolute w-4 h-full mx-2 text-gray-400 pointer-events-none">
                            <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>

                          <button
                            v-if="due_date_range && due_date_range.start"
                            class="absolute right-0 flex items-center justify-center w-6 h-6 mx-2 rounded-full top-2 group hover:bg-gray-300 rounderd-full"
                            type="button"
                            @click="due_date_range = null">
                            <X class="w-5 h-5 text-gray-400 group-hover:cursor-pointer" aria-hidden="true" />
                          </button>

                          <input
                            :value="
                              due_date_range && due_date_range.start
                                ? `${inputValue.start} - ${inputValue.end}`
                                : element.value && element.value.start
                                  ? `${$moment(element.value.start).format('YYYY-MM-DD')} - ${$moment(element.value.end).format(
                                    'YYYY-MM-DD'
                                  )}`
                                  : ''
                            "
                            :placeholder="$t('Due date')"
                            class="pr-2 h-[42px] bg-white dark:bg-dark-box-background border dark:border-dark-divider-border w-full rounded-md placeholder-gray-400 text-gray-900 focus:ring-1 outline-none border-gray-300 px-10 py-1.5 focus:ring-blue-light focus:border-blue-light"
                            v-on="inputEvents.start || inputEvents.end"
                            @input="
                              $utils.debounce(() => {
                                due_date_range = $event.target.value
                              }, 800)
                            ">
                        </div>
                      </template>
                    </DatePicker>
                  </div>
                  <AutoCompleteInput
                    v-else
                    v-model="element.value"
                    class="w-full bg-transparent border-none"
                    value-attr="value"
                    label-attr="name"
                    :value="element.value"
                    :icon="undefined"
                    :is-async="false"
                    :data="
                      element.input_type == 'Select' && element.input_options?.choices.length > 0
                        ? element.input_options?.choices
                        : element?.options
                          ? element.options
                          : []
                    "
                    :endpoint-async-url="getMetricSuggestionUrl(element)"
                    :is-box-background="isBoxBackground"
                    :placeholder="
                      element?.operator?.value == 'in' || element?.operator?.value == '__EXCLUDES__'
                        ? $t('Type word/s separated by comma')
                        : $t('Type a word or a sentence')
                    "
                    type="text"
                    classes="relative text-light-body-text dark:text-dark-body-text bg-white dark:bg-dark-screen-background rounded-md"
                    input-classes="overflow-hidden  focus:outline-none focus:ring-blue-light focus:border-blue-light  w-full rounded-md border-light-divider-border dark:border-dark-divider-border"
                    @changed="
                      ($event) => {
                        setValue($event)
                      }
                    "
                    @chosen="
                      ($event) => {
                        setValue($event)
                      }
                    " />
                </div>
              </div>
            </div>
          </div>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
import { DatePicker } from "v-calendar"
import AsyncMultiSelectCompaniesInput from "@/components/shared/AsyncMultiSelectCompaniesInput.vue"
import AsyncMultiSelectContactsInput from "@/components/shared/AsyncMultiSelectContactsInput.vue"
import MultiSelectInput from "@/components/shared/MultiSelectInput.vue"
import { Listbox, ListboxButton } from "@headlessui/vue"
import AutoCompleteInput from "@/components/shared/AutoCompleteInput.vue"
import { ListTodo, ChevronDown, X, User, Tag } from "lucide-vue-next"
import { markRaw } from "vue"

export default {
  components: {
    X,
    AsyncMultiSelectCompaniesInput,
    AsyncMultiSelectContactsInput,
    MultiSelectInput,
    DatePicker,
    AutoCompleteInput,
    ChevronDown,
    Listbox,
    ListboxButton
  },
  props: {
    isBoxBackground: {
      type: Boolean,
      default: false
    },
    metric: {
      type: Object,
      required: false
    }
  },
  emits: ["reset", "cancel", "filter", "change"],

  data() {
    return {
      due_date_range: null,
      collaborators: null,
      interaction_types: null,
      selected_tags: null,
      interaction_categories: null,
      status: null,
      element: null,
      user_menu_icon: User,
      tags_icon: markRaw(Tag),
      status_icon: markRaw(ListTodo)
    }
  },
  watch: {
    metric() {
      this.element = this.metric
    },
    collaborators() {
      this.setValue(this.collaborators)
    },
    interaction_types() {
      this.setValue(this.interaction_types)
    },
    selected_tags() {
      this.setValue(this.selected_tags)
    },
    interaction_categories() {
      this.setValue(this.interaction_categories)
    },
    status() {
      this.setValue(this.status)
    },
    due_date_range() {
      this.setValue(this.due_date_range)
    }
  },
  created() {
    this.element = this.metric
  },

  methods: {
    setValue(e) {
      this.element.value = e?.value ? e.value : e
      this.$emit("change", this.element)
    },
    getMetricSuggestionUrl() {
      return `/api/organizations/${this.$store.state.organization.id}/records/filter/`
    }
  }
}
</script>
<style scoped lang="postcss">
.ghost {
  @apply bg-gray-300 border-0 w-full;
}
.chosen {
  @apply bg-transparent border-0;
}
.chosen .line {
  opacity: 0;
}
</style>
